import { BackendRoute } from '../../../../config/index';
import { QueryKey } from '../../../../constants/query-key.const';
import { HttpException } from '../../../../exceptions/index';
import { useAppMutation } from '../../../../hooks/use-app-mutation.hook';
import ApiService from '../../../../services/api-service.util';

type EmbeddedSessionSyncResponse = {
  statusUpdated: boolean;
};

export const useSignatureEmbeddedSessionSync = (): {
  syncAfterEmbeddedSession: (signatureId: string) => Promise<EmbeddedSessionSyncResponse>;
} => {
  const { mutateAsync: syncAfterEmbeddedSession } = useAppMutation<
    EmbeddedSessionSyncResponse,
    HttpException,
    string
  >([QueryKey.SIGNATURE_SYNC_EMBEDDED_SESSION], {
    mutationFn: (signatureId: string) =>
      ApiService.post<EmbeddedSessionSyncResponse, Record<string, never>>(
        { endpoint: BackendRoute.SIGNATURES, routePath: [signatureId, 'sync-embedded-session'] },
        { body: {} },
      ),
  });

  return { syncAfterEmbeddedSession };
};
